<template>
    <v-container
        :class="{ 'pa-0': selectedMode }"
        fluid
    >
        <v-row density="compact">
            <v-col
                class="d-flex justify-start align-center"
            >
                <v-row density="compact">
                    <v-col
                        v-if="!selectedMode"
                        class="d-flex flex-shrink-1 flex-grow-0 align-center"
                    >
                        <v-icon
                            v-if="!active"
                            size="28"
                            color="grey-lighten-1"
                            :icon="mdiCheckboxBlankCircleOutline"
                        ></v-icon>
                        <v-icon
                            v-else
                            size="28"
                            color="success"
                            :icon="mdiCheckCircle"
                        ></v-icon>
                    </v-col>
                    <v-col
                        class="d-flex align-center"
                    >
                        <strong>{{ body.name }}</strong>
                        <v-chip
                            v-if="body.isSelf"
                            color="primary"
                            class="ml-2 text-uppercase font-weight-bold"
                            size="x-small"
                            label
                        >
                            You
                        </v-chip>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                v-if="!selectedMode"
            >
                <v-row density="compact">
                    <v-col>
                        <div
                            class="d-flex gap-2 align-center justify-end"
                        >
                            <v-chip
                                v-if="body.gender"
                                size="x-small"
                                label
                            >
                                {{ body.gender }}
                            </v-chip>
                            <v-chip
                                v-if="body.birthdate"
                                size="x-small"
                                label
                            >
                                {{ calcAge(body.birthdate) }} YRS
                            </v-chip>
                            <v-chip
                                v-if="body.heightFmt"
                                size="x-small"
                                label
                            >
                                {{ body.heightFmt }}
                            </v-chip>
                            <v-chip
                                v-if="body.weightFmt"
                                size="x-small"
                                label
                            >
                                {{ body.weightFmt }}
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>
                <v-row
                    class="mt-0"
                    density="compact"
                >
                    <v-col>
                        <div
                            class="d-flex align-center justify-end"
                        >
                            <div
                                v-if="body.updated"
                                class="text-size-fine py-2 text-right mr-2"
                            >
                                Updated {{ fmtDate(body.updated, 'medium') }}
                            </div>
                            <v-btn
                                v-if="!selectedMode"
                                @click.stop="() => onEditBody()"
                                color="primary"
                                variant="flat"
                                size="x-small"
                            >
                                Edit
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
</v-container>
</template>

<script lang="ts" setup>
    import { BodiesModel } from '~/models';
    import type { UserBody } from '~/types';
    import { calcAge, convertGramsToLb, convertMmToFtInString, fmtDate } from 'x1-base/utils';
    import type { MaybeRef } from 'vue';
    import { mdiCheckboxBlankCircleOutline, mdiCheckCircle } from '@mdi/js';


    const props = defineProps<{
        body: BodiesModel | UserBody;
        active?: MaybeRef<boolean>;
        selectedMode?: boolean;
    }>();

    const emit = defineEmits<{
        'edit-body': [body: Nullable<BodiesModel | UserBody>];
    }>();

    const onEditBody = () => {
        emit('edit-body', props.body);
    };
</script>

<style lang="scss" scoped></style>
